const CURSORS = {
  auto: {
    src:
      "https://www.datocms-assets.com/40484/1701088855-asap-default-cursor.png",
  },
  pointer: {
    src:
      "https://www.datocms-assets.com/40484/1701169690-asap-pointer-cursor.png",
  },
  grab: {
    src: "https://www.datocms-assets.com/40484/1701088860-asap-grab-cursor.png",
  },
  grabbing: {
    src:
      "https://www.datocms-assets.com/40484/1701088863-asap-grabbing-cursor.png",
  },
  loading: {
    src:
      "https://www.datocms-assets.com/40484/1701088875-asap-hover-cursor.png",
  },
};

export const cursor = style => {
  switch (style) {
    case "auto":
      return `cursor: url(${CURSORS.auto.src}), auto;`;
    case "pointer":
      return `cursor: url(${CURSORS.pointer.src}), pointer;`;
    case "grab":
      return `cursor: url(${CURSORS.grab.src}), grab !important;`;
    case "grabbing":
      return `cursor: url(${CURSORS.grabbing.src}), grabbing !important;`;
    case "load":
      return `cursor: url(${CURSORS.loading.src}), wait !important;`;
    default:
      return `cursor: url(${CURSORS.auto.src}), auto;`;
  }
};
